import React from "react";
import { Card, Grid } from '@alifd/next';
var Row = Grid.Row,
  Col = Grid.Col;
export var defaultEmptyContent = function defaultEmptyContent(locale) {
  return /*#__PURE__*/React.createElement(Card, {
    className: "list-empty",
    free: true
  }, locale.noData);
};
export var defaultRenderItem = function defaultRenderItem(record, index) {
  var columns = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var renderText = function renderText(val) {
    return val;
  };
  return /*#__PURE__*/React.createElement(Row, null, columns.map(function (col) {
    var dataIndex = col.dataIndex,
      span = col.span,
      fixedSpan = col.fixedSpan,
      align = col.align,
      alignHeader = col.alignHeader,
      _col$cell = col.cell,
      cell = _col$cell === void 0 ? renderText : _col$cell;
    var value = dataIndex !== undefined ? record[dataIndex] : undefined;
    var headerAlign = alignHeader || align;
    return /*#__PURE__*/React.createElement(Col, {
      key: index,
      span: span,
      fixedSpan: fixedSpan,
      style: headerAlign ? {
        textAlign: headerAlign
      } : undefined
    }, cell(value, index, record));
  }));
};